import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import OkDmvDetailedRenewal from './OkDmvDetailedRenewal';

class KsDlModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      renewal: props.renewal,
      show: false,
    };

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleShow() {
    this.setState({ show: true, });
  }

  handleClose() {
    this.setState({ show: false, });
  }

  sendNavigationRequest() {
    return null;
  }

  render() {
    const { show, } = this.state;
    const { renewal, } = this.state;
    return (
      <>
        <Button variant="primary" onClick={this.handleShow}>
          Details
        </Button>

        <Modal show={show} onHide={this.handleClose} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>
              Renewal Id&nbsp;
              {renewal.id}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {(() => {
              if (show) {
                return <OkDmvDetailedRenewal renewal={renewal} />;
              }
              return undefined;
            })()}
          </Modal.Body>
          <Modal.Footer />
        </Modal>
      </>
    );
  }
}

KsDlModal.propTypes = {
  renewal: PropTypes.instanceOf(Object).isRequired,
};

export default KsDlModal;
